import React, { Fragment } from 'react';
import { Popover, Transition } from '@headlessui/react';

const Dropdown = ({
	button,
	className,
	panelClassName,
	children,
	isOpen,
	forwardRef
}) => {
	return (
		<div ref={forwardRef} className={className ?? ''}>
			<Popover className="relative">
				{({ open }) => {
					open = isOpen;
					return (
						<>
							<Popover.Button as={Fragment}>{button}</Popover.Button>
							<Transition
								show={open}
								as={Fragment}
								enter="transition ease-out duration-200"
								enterFrom="opacity-0 translate-y-1"
								enterTo="opacity-100 translate-y-0"
								leave="transition ease-in duration-150"
								leaveFrom="opacity-100 translate-y-0"
								leaveTo="opacity-0 translate-y-1"
							>
								<Popover.Panel
									as="div"
									className={`
										absolute right-0 bottom-full md:top-full md:bottom-auto z-20 origin-bottom-right md:origin-top-right min-w-full w-max bg-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.3),_0_-2px_4px_-2px_rgba(0,0,0,0.3)] md:shadow-md md:shadow-gray-400 focus:outline-none
										${panelClassName ?? ''}
									`}
								>
									{children}
								</Popover.Panel>
							</Transition>
						</>
					);
				}}
			</Popover>
		</div>
	);
};

export default Dropdown;
